var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.505 1.864h14.99a2.14 2.14 0 0 1 2.141 2.141v14.99a2.141 2.141 0 0 1-2.141 2.141H4.505a2.141 2.141 0 0 1-2.141-2.141V4.005a2.14 2.14 0 0 1 2.141-2.141m2.677 12.848a1.606 1.606 0 1 0 0 3.212 1.606 1.606 0 0 0 0-3.212M5.576 9.36v2.14A6.424 6.424 0 0 1 12 17.924h2.141A8.566 8.566 0 0 0 5.576 9.36m0-4.283v2.141c5.913 0 10.707 4.794 10.707 10.707h2.141c0-7.096-5.752-12.848-12.848-12.848z",
    fill: "#F7A001",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.182 14.712a1.606 1.606 0 1 0 0 3.212 1.606 1.606 0 0 0 0-3.212M5.576 9.359V11.5A6.424 6.424 0 0 1 12 17.924h2.141A8.566 8.566 0 0 0 5.576 9.36",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.576 5.076v2.141c5.913 0 10.707 4.794 10.707 10.707h2.141c0-7.096-5.752-12.848-12.848-12.848z",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRss);
export default __webpack_public_path__ + "static/media/rss.7770bf4e.svg";
export { ForwardRef as ReactComponent };